module.exports = __webpack_public_path__ + "img/Wp_2082.361d4cb8.png";